import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Header({
  title, action, textColor, className,
}) {
  return <Lib.CardHeader className={className} title={title} action={action} textColor={textColor} />
}

Header.defaultProps = {
  action: null,
  className: '',
  textColor: '#000',
  title: '',
}

Header.propTypes = {
  action: PropType.element,
  className: PropType.string,
  textColor: PropType.string,
  title: PropType.node,
}

export default Header
